import { Colors } from '@revenuemarket/cds';
import { Tooltip } from 'antd';

import { show } from '~libs/intercome';

const BetaBadge = ({ title }: { title: string }) => {
  return (
    <Tooltip title={title}>
      <div
        style={{
          borderRadius: 5,
          background: 'rgba(27, 141, 251, 0.12)',
          display: 'flex',
          height: '20px',
          padding: '8px 4px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '2px',
          color: Colors.blue900,
          fontSize: 13,
          cursor: 'pointer',
        }}
        onClick={() => {
          show();
        }}
      >
        베타
      </div>
    </Tooltip>
  );
};

export default BetaBadge;
